import {Action} from '@ngrx/store';
import {PaginationHolder} from '@app/core/models/pagination.model';
import {Payroll} from '@app/core/models/payroll.model';

export enum EPayrollsActions {
	GetPayrolls = '[Payrolls] Get Payrolls',
	GetPayrollsSuccess = '[Payrolls] Get Payrolls Success',

	GetPayrollDetails = '[Payrolls] Get Payroll Details',
	GetPayrollDetailsSuccess = '[Payrolls] Get Payroll Details Success',
}

export class GetPayrolls implements Action {
	public readonly type = EPayrollsActions.GetPayrolls;

	constructor(public page: number, public pageSize: number, public searchQuery: string) {
	}
}

export class GetPayrollsSuccess implements Action {
	public readonly type = EPayrollsActions.GetPayrollsSuccess;

	constructor(public paginationHolder: PaginationHolder<Payroll>) {
	}
}

export class GetPayrollDetails implements Action {
	public readonly type = EPayrollsActions.GetPayrollDetails;

	constructor(public payrollId: number) {
	}
}

export class GetPayrollDetailsSuccess implements Action {
	public readonly type = EPayrollsActions.GetPayrollDetailsSuccess;

	constructor(public payroll: Payroll) {
	}
}

export type PayrollsActions =
	GetPayrolls |
	GetPayrollsSuccess |
	GetPayrollDetails |
	GetPayrollDetailsSuccess
	;
